export const spanish = 'Español';
export const english = 'Inglés';
export const translations = 'Traducciones';
export const translated = 'Traducido';
